import React, { useState } from "react";
import RoiCalculatorWidget from "./RoiCalculatorWidget";
import Industries_carousel_pa from "./Industries_carousel_pa";
import Industries_carousel_global from "./industries_carousel_global";
import { useTranslation } from "react-i18next";
import Modal_started from "../Home/Modal_started";

import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";

const POS_new = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  const features = [
    {
      tag: "Inventario al día",
      title: "Gestión de inventario automática",
      description:
        "Que reduzca pérdidas, avise cuando falten ingredientes y permita compras inteligentes.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-INVENTARIO-AUTOMATICA_kow1hl.png",
    },
    {
      tag: "Facturación electrónica",
      title: "Facturación digital eficiente",
      description:
        "Genera facturas electrónicas al instante, lleva un control de tus ventas y cumple con todos los requisitos fiscales sin complicaciones.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/FACTURACION-DIGITAL-EFICIENTE_bzc8pt.png",
    },
    {
      tag: "Control de mesas",
      title: "Gestión del personal",
      description:
        "Control de turnos, comisiones, rendimiento y roles dentro del sistema.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-PERSONAL_jzcmhm.png",
    },
    {
      tag: "InvuReport",
      title: "Reportes avanzados de ventas",
      description:
        "Gráficos y análisis por plato, turno, mes o empleado para tomar decisiones rápidas.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/REPORTES-AVANZADOS-DE-VENTAS_wzaucp.png",
    },
    {
      tag: "Control de mesas",
      title: "Control de mesas y reservas",
      description:
        "Visualización clara de ocupación, tiempos de permanencia y disponibilidad en tiempo real.",
      image:
        "https://img.invupos.com/webinvu/homenew/Whatsapp%20Catalogo-12%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Manejo de promociones",
      description:
        "Crear ofertas, combos y descuentos fácilmente sin afectar inventario ni contabilidad.",
      image:
        "https://img.invupos.com/webinvu/homenew/invu%20mockups%20multiple%20screens%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Para franquicias o sucursales",
      description:
        "Administración centralizada si tienen más de un local, con reportes consolidados.",
      image:
        "https://img.invupos.com/webinvu/homenew/1%202.png",
    },
  ];

  const featuresone = [
    {
      tag: "Nomima",
      title: "Nomima al instante con Invu POS",
      description:
        "Con Invu POS puedes calcular y pagar la nómina de tu equipo en segundos, manteniendo la transparencia y el control total de tu negocio.",
      image:
        "https://img.invupos.com/webinvu/POS%20NEW/Group%201171275534.png",
    },
    {
      tag: "Propinas integradas",
      title: "Divide las propinas de forma rapida",
      description:
        "Nuestro sistema reparte las propinas de manera justa, rápida y automática, sin errores ni discusiones.",
      image:
        "https://img.invupos.com/webinvu/POS%20NEW/pexels-olly-3801439%201.png",
    },
    {
      tag: "E-commerce",
      title: "E-commerce a tu alcance",
      description:
        "Desde la venta en línea hasta la cocina y el delivery, para que vendas más sin perder el control.",
      image:
        "https://img.invupos.com/webinvu/POS%20NEW/Whatsapp%20Catalogo-3%201%20%281%29.png",
    },
    {
      tag: "Lealtad",
      title: "Punch Card digital",
      description:
        "Con nuestras tarjetas digitales, tus clientes acumulan puntos y beneficios que los harán volver una y otra vez a tu negocio.",
      image:
        "https://img.invupos.com/webinvu/POS%20NEW/Group%201171275531.png",
    },
  ];

  const integrations = "https://img.invupos.com/webinvu/POS%20NEW/INVU_POS_El_Salvador-9_3_t18s5r%20%281%29.png"

  const features1 = [
    { text: "Incrementa tickets" },
    { text: "Cocina siempre sincronizada" },
    { text: "Preparación más rápida" },
    { text: "Flujo de trabajo eficiente" },
    { text: "Reduce errores" },
    { text: "Alerta de comanda" },
    { text: "Pedidos Online" },
    { text: "Reportes de cocina" },
    { text: "Mide los tiempos en cocina" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + features.length) % features.length);
  };

  // ✅ Siempre devuelve 3 cards, ciclando los índices con módulo
  const getVisibleCards = () => {
    const cards = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % features.length;
      cards.push({ ...features[index], originalIndex: index });
    }
    return cards;
  };

  const faqs = [
    {
      question: "¿Qué es Invu POS y por qué es diferente a otros sistemas? ",
      answer:
        "Invu POS es un sistema de punto de venta completo y moderno que centraliza tus ventas, inventarios, reportes y operaciones en tiempo real. Es rápido, fácil de usar y está diseñado para crecer contigo. Además, funciona en la nube, por lo que siempre tienes acceso a tus datos desde cualquier dispositivo.",
    },
    {
      question: "¿En qué tipos de negocios funciona Invu POS?",
      answer:
        "Es ideal para restaurantes, cafeterías, bares, retail, gimnasios, tiendas especializadas y servicios. El sistema se adapta a cualquier tipo de operación con módulos personalizables como cocina (KDS), ecommerce, lealtad, delivery y más. ",
    },
    {
      question: "¿Qué beneficios obtengo al usar Invu POS?",
      answer:
        "Tendrás control total de tu negocio: reportes en tiempo real, manejo de inventarios, control de ventas, usuarios, horarios, integraciones de pago, delivery y facturación. Todo en un solo sistema para que operes sin complicaciones. ",
    },
    {
      question: "¿Qué equipos necesito para usar Invu POS?",
      answer:
        "Invu POS funciona en computadores, tablets y equipos táctiles. Si no tienes hardware, contamos con las terminales y accesorios necesarios para tu operación: desde pantallas táctiles hasta impresoras y cajas de dinero. Solo necesitas conexión a internet y estás listo para vender. ",
    },
    {
      question: "¿Cuánto tiempo toma implementar Invu POS? ",
      answer:
          "La activación es rápida. Un asesor te acompaña en la configuración, carga de productos, integración de pagos y capacitación del personal. En pocas horas puedes tener todo funcionando y comenzar a operar sin afectar tu día a día. ",
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [isOpen, setIsOpen] = useState(false);

  const extendedFeatures = [...features, ...features, ...features];
  const extendedFeatures1 = [...featuresone, ...featuresone, ...featuresone];
  

        // const extendedFeatures = [...features, ...features, ...features]; 
        const extendedFeaturesList = t("featuresecommercenew", { returnObjects: true });
        const extendedFeaturesList1 = t("posfeatures", { returnObjects: true });

        const faqList = t("faqsposnew", { returnObjects: true });
      
        const isMobile =
        typeof window !== "undefined" && window.innerWidth < 768;
      
        const location = useLocation();
        const prefix = useLocalePrefix();

      const cardsPerSlide = isMobile ? 1 : 3;

  return (
    <>
     {isOpen && <Modal_started setIsOpen={setIsOpen} />}
          <div className="px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl">
          {/* Grid con proporciones personalizadas */}
          <div className="grid lg:grid-cols-[45%_55%] gap-12 items-center px-8">
            {/* Contenido de texto */}
            <div className="space-y-8">
              <h1 className="text-6xl md:text-6xl lg:text-6xl font-bold mt-8">
              {t("posherotitle1")}{" "}
                <span className="text-blue-600">{t("posherotitlespan")}</span> {t("posherotitle2")}
              </h1>

              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
              {t("posherodescription")}
              </p>

              <div class="mt-6 lg:mt-12 mb-6">
                    <span class="text-xs font-semibold text-gray-500 uppercase tracking-widest">{t("posheroavailable")}</span>
                    <div class="mt-4 flex gap-x-8">
                      <a href="https://bit.ly/4cXCHQm" target="_blank">
                        <svg class="icon text-gray-500 hover:text-gray-800 transition duration-300 cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                            <path fill="currentColor" d="m3.001 5.479l7.377-1.016v7.127H3zm0 13.042l7.377 1.017v-7.04H3zm8.188 1.125L21.001 21v-8.502h-9.812zm0-15.292v7.236h9.812V3z"/>
                        </svg>
                      </a>
                      <a href="https://bit.ly/3W8xWN4" target="_blank">
                        <svg class="icon text-gray-500 hover:text-gray-800 transition duration-300 cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 315">
                            <path fill="currentColor" d="M213.803 167.03c.442 47.58 41.74 63.413 42.197 63.615c-.35 1.116-6.599 22.563-21.757 44.716c-13.104 19.153-26.705 38.235-48.13 38.63c-21.05.388-27.82-12.483-51.888-12.483c-24.061 0-31.582 12.088-51.51 12.871c-20.68.783-36.428-20.71-49.64-39.793c-27-39.033-47.633-110.3-19.928-158.406c13.763-23.89 38.36-39.017 65.056-39.405c20.307-.387 39.475 13.662 51.889 13.662c12.406 0 35.699-16.895 60.186-14.414c10.25.427 39.026 4.14 57.503 31.186c-1.49.923-34.335 20.044-33.978 59.822M174.24 50.199c10.98-13.29 18.369-31.79 16.353-50.199c-15.826.636-34.962 10.546-46.314 23.828c-10.173 11.763-19.082 30.589-16.678 48.633c17.64 1.365 35.66-8.964 46.64-22.262"/>
                        </svg>
                      </a>
                      <a href="https://bit.ly/4cJt3Be" target="_blank">
                          <svg class="icon text-gray-500 hover:text-gray-800 transition duration-300 cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 20 20">
                              <path fill="currentColor" fill-rule="evenodd" d="M12.735 1.828L13.6.254a.172.172 0 0 0-.3-.164l-.874 1.59a5.987 5.987 0 0 0-2.428-.508c-.869 0-1.69.181-2.424.506L6.698.09a.171.171 0 0 0-.232-.069a.169.169 0 0 0-.069.232l.866 1.572c-1.7.874-2.85 2.537-2.849 4.447l11.166-.001c0-1.91-1.146-3.57-2.845-4.444m-5.278 2.43a.467.467 0 1 1 .001-.934a.467.467 0 0 1 0 .935M15.542 6.7l.002 8.012c0 .481-.262.897-.648 1.127a1.31 1.31 0 0 1-.675.19l-.904.001v2.734a1.237 1.237 0 0 1-1.489 1.21a1.238 1.238 0 0 1-.99-1.209V16.03H9.163v2.735A1.237 1.237 0 0 1 7.925 20a1.239 1.239 0 0 1-1.238-1.235V16.03h-.901c-.521 0-.967-.3-1.182-.736a1.298 1.298 0 0 1-.141-.581l-.002-8.01zM2.74 6.47c.684 0 1.24.553 1.24 1.234v5.17a1.238 1.238 0 0 1-1.922 1.03a1.231 1.231 0 0 1-.557-1.03L1.5 7.703c0-.68.555-1.234 1.24-1.234m14.52-.001c.684 0 1.24.552 1.24 1.234v5.169c0 .683-.555 1.235-1.239 1.235c-.685 0-1.24-.552-1.24-1.235V7.702c0-.682.554-1.235 1.238-1.234M12.54 3.325a.467.467 0 1 1 0 .933a.467.467 0 1 1 0-.933"/>
                          </svg>
                      </a>
                    </div>
                  </div>

                  <div className="mt-8 flex flex-wrap gap-4">
                <button  onClick={() => {
                setIsOpen(true);
              }} className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-16 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                    {t("posherobutton1")}
                </button>
                <button  onClick={() => {
                setIsOpen(true);
              }} className="px-16 py-4 rounded-full bg-white shadow text-gray-900 font-semibold border text-lg">{t("posherobutton2")}</button>
                </div>
            </div>

            {/* Imagen */}
            <div className="relative lg:my-10 lg:mx-4 my-4">
              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/POS%20new/new%20cover%20invu%20pos%204.png"
                  alt="Mockup Invu POS"
                  className="rounded-2xl w-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="px-6 py-12 md:py-20">
      <div className="max-w-7xl mx-auto bg-gradient-to-br from-blue-600 to-blue-800 rounded-3xl p-10 md:p-16 relative overflow-hidden">
             {/* Decorative Circle */}
             <div className="absolute -right-32 top-40  -translate-y-1/2 w-[550px] h-[550px] opacity-20">
              <img src="https://img.invupos.com/webinvu/POS%20NEW/logo-INVU-POS-blanco_1_7_dvfhgc%20%281%29.png" />
            </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">

        <img src="https://img.invupos.com/webinvu/POS%20new/Cover-new-pos.png"/>          
          {/* --- IZQUIERDA (Contenido) --- */}
          <div className="text-white space-y-4">
          <span class="inline-flex items-center gap-x-1.5 py-2 px-5 rounded-full text-xs font-bold tracking-wide bg-[#78A2F5] text-white">DEMO</span>

            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
            {t("posctatitle1")}
            </h1>

            <p className="text-lg md:text-2xl max-w-xl leading-relaxed opacity-90">
            {t("posctadescription")}
            </p>

            <button  onClick={() => {
                setIsOpen(true);
              }} className="bg-white text-blue-700 font-semibold text-lg px-10 py-4 rounded-full shadow-md hover:scale-105 transition">
             {t("posctabutton1")}
            </button>
          </div>

        </div>
      </div>
    </section>

      <Industries_carousel_global/>

      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-center gap-6 mb-12 text-center lg:text-left">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 max-w-2xl leading-tight">
          {t("sliderpostitle")}
          </h1>

          <button  onClick={() => {
                setIsOpen(true);
              }} className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-base sm:text-lg px-10 sm:px-16 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105">
           {t("posherobutton1")}
          </button>
        </div>

        {/* Carousel */}
    <div className="relative overflow-hidden">
      <div
        className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
        style={{
          transform: `translateX(-${currentSlide * (100 / cardsPerSlide)}%)`,
        }}
      >
        {extendedFeaturesList.map((feature, idx) => (
          <div
            key={idx}
            className="w-full md:w-1/3 flex-shrink-0 px-3 md:px-4 animate-fadeup"
            style={{ animationDelay: `${(idx % 3) * 0.1}s` }}
          >
            {/* Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-700 ease-in-out overflow-hidden h-full flex flex-col">
              {/* Brillo diagonal */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>

              {/* Borde brillante */}
              <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-blue-100 transition-all duration-700"></div>

              {/* Tag */}
              <div className="flex items-center justify-between mb-6">
                <span className="text-blue-600 font-semibold text-sm">
                  {feature.tag}
                </span>
                <div className="bg-blue-600 rounded-full p-1.5 flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-white"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M13 4L6 11L3 8"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                {feature.description}
              </p>

              {/* Image */}
              <div className="relative bg-white rounded-2xl overflow-hidden flex items-center justify-center h-64 mb-6">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="object-contain max-h-full max-w-full transition-transform duration-700 ease-in-out group-hover:scale-110"
                />
              </div>

              {/* Plus Button */}
              <div>
                <button className="mt-auto bg-blue-50 hover:bg-blue-100 rounded-full p-3 transition-transform duration-500 hover:scale-110 shadow-sm">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 4V16M4 10H16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botones */}
      <div className="flex justify-center gap-4 mt-6">
        <button
          onClick={prevSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Anterior"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          onClick={nextSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Siguiente"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Indicadores */}
      <div className="flex justify-center gap-2 mt-6">
        {features.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            className={`h-2 rounded-full transition-all ${
              idx === currentSlide
                ? "w-8 bg-blue-600"
                : "w-2 bg-gray-300 hover:bg-gray-400"
            }`}
            aria-label={`Ir a slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  </div>
</div>

      {/* SISTEMA INTEGRADO */}
 <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <h2 className="text-4xl sm:text-5xl font-extrabold">
          {t("poscta2title1")} <span className="text-blue-600">{t("poscta2titlespan")}</span>
        </h2>
        <div className="mt-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="max-w-2xl text-gray-700 text-lg">
            {t("poscta2description")}
            <div className="mt-6">
            <Link 
            to={"/mas-herramientas/integraciones"} className="px-6 py-3 rounded-full bg-blue-600 text-white font-semibold inline-block">{t("poscta2button")}</Link>
            </div>
          </div>
          <div className="max-w-2xl mx-auto">
            {integrations ? (
              <img src={integrations} alt="Integraciones" className="w-full rounded-2xl" />
            ) : (
              <div className="w-full h-72 bg-gray-100 rounded-2xl" />
            )}
          </div>
        </div>

        {/* Métricas */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">{t("kdscard1title1")}</div>
            <div className="mt-3 text-5xl font-extrabold">100<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">{t("kdscard1description1")}</p>
          </div>
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">{t("kdscard2title1")}</div>
            <div className="mt-3 text-5xl font-extrabold">99<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">{t("kdscard2description1")}</p>
          </div>
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">{t("kdscard3title1")}</div>
            <div className="mt-3 text-5xl font-extrabold">45<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">{t("kdscard3description1")}</p>
          </div>
        </div>
      </section>

      <div className="min-h-screen bg-gray-100 py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left Card - Aliados */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden">
              {/* Header */}

              <h2 className="text-4xl lg:text-5xl font-bold text-black mb-8">
                <span className="text-blue-600">{t("kioskcta1span")}</span> {t("kioskcta1title")}
              </h2>

              {/* Description */}
              <p className="text-gray-700 text-lg leading-relaxed mb-12">
             {t("kioskcta1description")}
              </p>

              {/* Imagen CLAU.IO */}
              <div className="relative bg-gray-50 rounded-2xl overflow-hidden h-80 mb-8 flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/Kiosk_new/img3.png"
                  alt="Plataforma CLAU.IO"
                  className="w-full h-full object-contain"
                />
              </div>

             {/* CTA Button */}
              <Link
              to={`${prefix}` + "/productos/quioscos"}
              onClick={() => window.scrollTo(0, 0)}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-10 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
               {t("kioskcta1button")}
              </Link>
            </div>

            {/* Right Card - Loyalty */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden flex flex-col">
              {/* Header */}
              <div className="text-center mb-8">
                <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                  <span className="text-black">{t("kioskcta2title")} </span>
                  <span className="text-blue-600">{t("kioskcta2span")}</span>
                </h2>

                {/* Description */}
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {t("kioskcta2description")}
                </p>

                {/* CTA Button */}
                <Link
                to={`${prefix}` + "/productos/programa-de-lealtad"}
                onClick={() => window.scrollTo(0, 0)}
                className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-24 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                  {t("kioskcta2button")}
                </Link>
              </div>

              {/* Imagen de celulares */}
              <div className="relative flex-1 flex items-end justify-center mt-8">
                <div className="w-full h-96 bg-gray-50 rounded-2xl overflow-hidden flex items-center justify-center">
                  <img
                    src="https://img.invupos.com/webinvu/Kiosk_new/img4.png"
                    alt="Apps móviles Loyalty"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="px-6 py-12 md:py-20">
      <div className="max-w-7xl mx-auto bg-gradient-to-br from-blue-600 to-blue-800 rounded-3xl p-10 md:p-16 relative overflow-hidden">

        <div className="grid lg:grid-cols-2 gap-12 items-center">
               {/* Decorative Circle */}
               <div className="absolute -left-32 top-40 -translate-y-1/2 w-[550px] h-[550px] opacity-20">
              <img src="https://img.invupos.com/webinvu/POS%20NEW/logo-INVU-POS-blanco_1_7_dvfhgc%20%281%29.png" />
            </div>

          {/* --- IZQUIERDA (Contenido) --- */}
          <div className="text-white space-y-8">

            <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
              {t("kioskcta3title")}
            </h1>

            <p className="text-lg md:text-2xl max-w-xl leading-relaxed opacity-90">
              {t("kioskcta3description")}
            </p>

            <button 
             onClick={() => {
              setIsOpen(true);
            }}
            className="bg-white text-blue-700 font-semibold text-lg px-10 py-4 rounded-full shadow-md hover:scale-105 transition">
              {t("kioskcta3button")}
            </button>
          </div>

          <img src="https://img.invupos.com/webinvu/Kiosk_new/img5.png"/>

        </div>
      </div>
    </section>

      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-center gap-6 mb-12 text-center lg:text-left">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 max-w-2xl leading-tight">
          {t('posslider2title1')}
          </h1>

          <button className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-base sm:text-lg px-10 sm:px-16 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105">
            {t("posherobutton1")}
          </button>
        </div>

          {/* Carousel */}
    <div className="relative overflow-hidden">
      <div
        className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
        style={{
          transform: `translateX(-${currentSlide * (100 / cardsPerSlide)}%)`,
        }}
      >
            {extendedFeaturesList1.map((feature, idx) => (
              <div
              key={idx}
              className="w-full md:w-1/3 flex-shrink-0 px-3 md:px-4 animate-fadeup"
              style={{ animationDelay: `${(idx % 3) * 0.1}s` }}
              >
                {/* Card */}
                <div className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-700 ease-in-out overflow-hidden h-full flex flex-col">
                  {/* Brillo diagonal */}
                  <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>

                  {/* Borde brillante */}
                  <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-blue-100 transition-all duration-700"></div>

                  {/* Tag */}
                  <div className="flex items-center justify-between mb-6">
                    <span className="text-blue-600 font-semibold text-sm">
                      {feature.tag}
                    </span>
                    <div className="bg-blue-600 rounded-full p-1.5 flex items-center justify-center">
                      <svg
                        className="w-4 h-4 text-white"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M13 4L6 11L3 8"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                    {feature.description}
                  </p>

                  {/* Image */}
                  <div className="relative bg-white rounded-2xl overflow-hidden flex items-center justify-center h-64 mb-6">
                    <img
                      src={feature.image}
                      alt={feature.title}
                      className="object-contain max-h-full max-w-full transition-transform duration-700 ease-in-out group-hover:scale-110"
                    />
                  </div>

                  {/* Plus Button (siempre al fondo) */}
                  <div>
                  <button className="mt-auto bg-blue-50 hover:bg-blue-100 rounded-full p-3 transition-transform duration-500 hover:scale-110 shadow-sm">
                    <svg
                      className="w-5 h-5 text-blue-600"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M10 4V16M4 10H16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Botones */}
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={prevSlide}
              className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
              aria-label="Anterior"
            >
              <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15 18L9 12L15 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              onClick={nextSlide}
              className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
              aria-label="Siguiente"
            >
              <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>

          {/* Indicadores */}
          <div className="flex justify-center gap-2 mt-6">
            {features.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSlide(idx)}
                className={`h-2 rounded-full transition-all ${
                  idx === currentSlide
                    ? "w-8 bg-blue-600"
                    : "w-2 bg-gray-300 hover:bg-gray-400"
                }`}
                aria-label={`Ir a slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>


      <div className="min-h-screen bg-white py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left Side - Imagen FAQ Ecommerce */}
            <div className="flex justify-center lg:justify-center">
              <img
                src="https://img.invupos.com/webinvu/POS%20new/10.png"
                alt="Preguntas frecuentes Ecommerce"
                className=" block w-full max-w-[320px] h-auto object-contain"
              />
            </div>

            {/* Right Side - FAQ Section */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
               {t("posfaqnew")}
              </h2>

              {/* FAQ Items */}
              <div className="space-y-4">
                {faqList.map((faq, index) => (
                  <div key={index} className="border-b border-gray-200">
                    <button
                      onClick={() => toggleFaq(index)}
                      className="w-full py-6 flex items-center justify-between text-left hover:text-gray-600 transition-colors"
                    >
                      <span className="text-lg font-medium text-gray-900 pr-4">
                        {faq.question}
                      </span>
                      <span className="text-2xl text-gray-500 flex-shrink-0">
                        {openIndex === index ? "−" : "+"}
                      </span>
                    </button>
                    {openIndex === index && (
                      <div className="pb-6 text-gray-600 leading-relaxed">
                        {faq.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA Banner */}
          <div className=" relative bg-gradient-to-r from-[#0056FB] to-[#003395] rounded-3xl p-12 overflow-hidden max-w-6xl mx-auto">
            {/* Decorative Circle */}
            <div className="absolute right-2 top-1/2 -translate-y-1/2 w-64 h-64 opacity-20">
              <img src="https://img.invupos.com/webinvu/POS%20NEW/logo-INVU-POS-blanco_1_7_dvfhgc%20%281%29.png" />
            </div>

            <div className="relative z-10 max-w-3xl mx-auto text-center">
              <h3 className="text-3xl lg:text-5xl font-bold text-white mb-8 leading-tight">
             {t("poscta4title")}
              </h3>
              <button  onClick={() => {
                setIsOpen(true);
              }} className="bg-white hover:bg-gray-100 text-blue-600 font-bold px-8 py-4 rounded-full transition-colors text-lg uppercase tracking-wide">
              {t("poscta4button1")}
              </button>
            </div>
          </div>
        </div>
      </div>
      
    </>
  )
}

export default POS_new